<template>
  <section class="promotion-artwork" :style="backgroundStyle" aria-label="优惠活动主图">
    <img v-if="configuration.mainImageUrl || referenceAsset('discount',16)" :src="configuration.mainImageUrl || referenceAsset('discount',16)" alt="优惠活动" @error="imageFailed = true" :class="{ 'image-failed': imageFailed }" />
    <div v-if="error || imageFailed" class="artwork-error" role="status">{{ error || '活动主图暂时无法显示' }}<button @click="load">重试</button></div>
  </section>
</template>
<script setup>
import { computed, onMounted, ref } from 'vue'
import { webApi } from '../services/webApi'
import { referenceAsset } from '../config/referencePresentation.js'
const configuration = ref({})
const error = ref('')
const imageFailed = ref(false)
const backgroundStyle = computed(() => ({ backgroundImage: configuration.value.backgroundImageUrl ? `url(${JSON.stringify(configuration.value.backgroundImageUrl)})` : undefined }))
let sequence = 0
async function load() {
  const ticket = ++sequence
  error.value = ''
  try {
    const result = await webApi.promotionListPage()
    if (ticket !== sequence) return
    configuration.value = result || {}
    imageFailed.value = false
  } catch (e) {
    if (ticket !== sequence) return
    configuration.value = {}
    error.value = e.message || '活动主图加载失败'
  }
}
onMounted(load)
</script>
